// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"ef3b7d4ec13f3a025ce3","678":"8b9c9b8d30ebabe76ae9"}[chunkId] + ".js";
};